import React, { FC } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import Group from 'components_new/pages/Group'
import GroupMembers from 'components_new/pages/GroupMembers'
import GroupResources from 'components_new/pages/GroupResources'
import GroupSettings from 'components_new/pages/GroupSettings'
import GroupTasks from 'components_new/pages/GroupTasks'

import Groups from 'components_new/pages/Groups'

import { useIsAuthenticated } from 'redux/hooks/SignedInAccount'

import AuthRoute from './AuthRoute'

const Routes: FC = () => {
  const isAuthenticated = useIsAuthenticated()

  return (
    <Switch>
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <GroupMembers />}
        path="/groups/:id/members"
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <GroupResources />}
        path="/groups/:id/resources"
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <GroupSettings />}
        path="/groups/:id/settings"
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <GroupTasks />}
        path="/groups/:id/tasks"
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <Group />}
        path={'/groups/:id'}
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <Groups />}
        path={'/groups'}
      />
      <Route path={'/groups/*'}>
        <Redirect to="/groups" />
      </Route>
    </Switch>
  )
}

export default Routes
